import React, { Component } from 'react'
import { Router } from 'react-static'
import styled, { injectGlobal } from 'styled-components'
import Routes from 'react-static-routes'

import Navigation from './containers/Navigation'
import Weather from './containers/Weather'
import raleway from './fonts/Raleway/Raleway-Regular.ttf'
import playfair from './fonts/Playfair_Display/PlayfairDisplay-Black.ttf'

const red = `rgba(230, 57, 70, 1)`
const white = `rgba(241, 250, 238, 1)`
const darkblue = `rgba(23, 104, 172, 1)`
const lightblue = `rgba(6, 190, 225, 1)`
const green = `rgba(168, 218, 220, 1)`
const pink = `#FF6B98`

injectGlobal`

  @font-face {
     font-family: 'Playfair';
     src: url(${playfair});
  }
  @font-face {
     font-family: 'Raleway';
     src: url(${raleway});
  }

  body {
    border-top: 6px solid ${darkblue};
    background: ${white};
    font-size: 20px;
    margin: 0;
    padding: 0;
    font-family: 'Playfair Display';
  }
  p,h1,h2,h3,div,span,a,ul,li{
    margin: 0;
    padding: 0;
  }
  button{
    font-family: 'Raleway';
  }
  a{
    text-decoration:none;
    color: black;
    font-family: 'Raleway';
    font-weight: 200;
  }
  img {
    max-width: 100%;
    height: auto;
    display: block;
  }
  blockquote,cite {
    margin: 0;
    padding: 0;
    border: 0;
    font-size: 100%;
    font: inherit;
    vertical-align: baseline;
  }

  ol, ul {
    list-style: none;
  }
  blockquote, q {
    quotes: none;
  }
  blockquote:before, blockquote:after,
  q:before, q:after {
    content: '';
    content: none;
  }
  .sr-only {
    position: absolute;
    width: 1px;
    height: 1px;
    padding: 0;
    margin: -1px;
    overflow: hidden;
    clip: rect(0,0,0,0);
    border: 0;
  }
`

const App = () => (
  <Router>
    <div>
      <main>
        <Routes />
      </main>
      <footer>
        <Navigation />
      </footer>
    </div>
  </Router>
)
export default App



// WEBPACK FOOTER //
// /opt/build/repo/src/App.js